import React from 'react';
import propTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import { Package } from 'lucide-react';
import SimpleContainer from 'tailwind-components/SimpleContainer/SimpleContainer';
import ExternalLinkButton from 'tailwind-components/ExternalLinkButton/ExternalLinkButton';

export default function BonusSidebar({ bonusItems, bonusLoader }) {
  if (bonusLoader.isActive) {
    return (
      <div className='flex min-h-0 flex-1 grow items-center justify-center p-8'>
        <CircularProgress size={32} />
      </div>
    );
  }

  if (bonusLoader.isHidden) {
    return (
      <div className='flex min-h-0 flex-1 grow flex-col items-center justify-center gap-3 p-8 text-center'>
        <Package size={40} className='text-gray-300' />
        <p className='m-0 text-sm text-gray-400'>
          No Information Found for this Carrier
        </p>
      </div>
    );
  }

  if (!bonusItems?.length) {
    return null;
  }

  return (
    <div className='min-h-0 flex-1 grow h-full'>
      <SimpleContainer className='gap-4'>
        {bonusItems.map((bonusElement, i) => {
          const label = Object.keys(bonusElement)[0];
          const url = Object.values(bonusElement)[0];

          return (
            <div
              key={`${label}-${i}`}
              className='flex flex-col gap-2 border-b border-grey-lighter pb-3 last:border-b-0 last:pb-0'
            >
              <p className='m-0 font-semibold text-primary-darkened'>{label}</p>
              <ExternalLinkButton href={url} text='View bonus' size='small' />
            </div>
          );
        })}
      </SimpleContainer>
    </div>
  );
}

BonusSidebar.propTypes = {
  bonusItems: propTypes.array,
  bonusLoader: propTypes.shape({
    isActive: propTypes.bool,
    isHidden: propTypes.bool
  }).isRequired
};
